import { useState, useEffect, useCallback } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useGetWellsFargoApiCredential = (organizationId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCredential = useCallback(async () => {
    if (!organizationId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await WellsFargoSettingsApi.getApiCredential(
        organizationId,
      );
      setData(response.data);
    } catch (err) {
      setError(err);
      console.error('Failed to load Wells Fargo API credential', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchCredential();
  }, [fetchCredential]);

  return {
    data,
    loading,
    error,
    refetch: fetchCredential,
  };
};
